/**
 * Checks if the given route pattern matches the current path.
 * If the pattern includes a wildcard "/for/*", it is converted into a regex. Otherwise, an exact match is used.
 */
export const matchRoute = (pattern: string, path: string): boolean => {
  // Special case for /for/* pattern to match one or two URL parts
  if (pattern === "/for/*/") {
    const regex = /^\/for\/[^/]+(\/[^/]+)?\/?$/;
    return regex.test(path);
  }
  return pattern === path;
};
